import { useEffect } from 'react';

import { Label } from '@/components/ui/Label';
import { XStack, YStack } from '@/components/ui/layout/layout';

import { DeliveryChannelDropdown } from './DeliveryChannelDropdown';
import { useChannelConnectionQuery } from './msg-channels.query';
import {
  MessagingChannelTypes,
  MESSAGING_DELIVERY_OFF,
  type MessagingDeliveryChannel,
} from './msg-channels.types';

export function DeliveryChannelSelect({
  deliveryChannel,
  setDeliveryChannel,
}: {
  deliveryChannel: MessagingDeliveryChannel;
  setDeliveryChannel: (v: MessagingDeliveryChannel) => void;
}) {
  const imessage = useChannelConnectionQuery(MessagingChannelTypes.IMESSAGE);
  const whatsapp = useChannelConnectionQuery(
    MessagingChannelTypes.WHATSAPP_BUSINESS
  );
  const requestedSelection =
    deliveryChannel === MESSAGING_DELIVERY_OFF ? null : deliveryChannel;
  const selectedQuery =
    requestedSelection === MessagingChannelTypes.IMESSAGE ? imessage : whatsapp;
  const selectedChannelUnavailable =
    requestedSelection !== null &&
    selectedQuery.isSuccess &&
    (!selectedQuery.data?.identifier ||
      !selectedQuery.data.has_active_conversation);

  useEffect(() => {
    if (selectedChannelUnavailable) {
      setDeliveryChannel(MESSAGING_DELIVERY_OFF);
    }
  }, [selectedChannelUnavailable, setDeliveryChannel]);

  const anyChannelConnected = Boolean(
    imessage.data?.identifier || whatsapp.data?.identifier
  );

  return (
    <XStack className="items-center justify-between gap-3">
      <YStack className="min-w-0 gap-0.5">
        <Label className="font-medium text-sm">Messages</Label>
        <p className="text-xs text-foreground-muted">
          {anyChannelConnected
            ? 'Text me a report on one connected channel'
            : 'Connect iMessage or WhatsApp'}
        </p>
      </YStack>
      <DeliveryChannelDropdown
        channel={deliveryChannel}
        onChange={setDeliveryChannel}
      />
    </XStack>
  );
}
